/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGethomeGetHomeResult
 */
export interface JumboGethomeGetHomeResult {
    /**
     * 
     * @type {string}
     * @memberof JumboGethomeGetHomeResult
     */
    message?: string;
}

/**
 * Check if a given object implements the JumboGethomeGetHomeResult interface.
 */
export function instanceOfJumboGethomeGetHomeResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGethomeGetHomeResultFromJSON(json: any): JumboGethomeGetHomeResult {
    return JumboGethomeGetHomeResultFromJSONTyped(json, false);
}

export function JumboGethomeGetHomeResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGethomeGetHomeResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function JumboGethomeGetHomeResultToJSON(value?: JumboGethomeGetHomeResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

